// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_EmployeesPayrollSummaryResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { Payroll_EmployeeSummaryRow } from './Payroll_EmployeeSummaryRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_EmployeesPayrollSummaryResponseDados = Payroll_EmployeeSummaryRow[];

export type Payroll_EmployeesPayrollSummaryResponse = ApiResponse<Payroll_EmployeesPayrollSummaryResponseDados>;

registerResponseContract('Payroll_EmployeesPayrollSummaryResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      user_id:    { type: 'string',  required: true },
      user_name:  { type: 'string',  required: true },
      user_email: { type: 'string',  required: true },
      franchises: {
        type: 'array',
        required: false,
        items: {
          franchise_id:            { type: 'number',  required: true },
          franchise_name:          { type: 'string',  required: true },
          latest_period_end:       { type: 'string',  required: false },
          latest_period_status:    { type: 'number',  required: false },
          days_since_last_payroll: { type: 'number',  required: false },
          has_active_rules:        { type: 'boolean', required: true },
        },
      },
    },
  },
})
